import { OptionsObject, SnackbarKey, SnackbarMessage } from 'notistack';
import { useNotificationMutationFactory } from '@dispatch/web/ui';

export const useValidateTaskErrors = (
  notifyError: (
    title: string,
    message: SnackbarMessage,
    options?: OptionsObject | undefined
  ) => SnackbarKey
) => {
  const notifications = useNotificationMutationFactory('Task', 'update');

  const handleError = (error: { status: number; message: string }) => {
    if (error.status === 400) {
      notifyError('Error', error.message);
    } else {
      notifications.notifyError();
    }
  };

  return {
    handleError,
  };
};
